// Barrel export for modal components
export { default as SignatureModal } from '../../../shared/components/modals/SignatureModal/SignatureModal';

// Export types
export type { SignatureModalProps } from '../../../shared/components/modals/SignatureModal/SignatureModalProps';